import "../../styles/blog.scss";
import SecondaryPagination from "../SecondaryPagination/SecondaryPagination.jsx";
import Pagination from "../Pagination/Pagination.jsx";
// import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right-filled.svg";
import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right-thin.svg";
import { ReactComponent as PlaySvg } from "../../assets/icons/play.svg";

import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../AppContext.jsx";
import { langComponent } from "../../constants/index.jsx";
import useBlogs from "../../hooks/useBlogs.js";
import { format } from "date-fns";
import { useNavigate, useSearchParams } from "react-router-dom";
import ScrollToTop from "../common/ScrollToTop/index.jsx";
import blogArchitecture from "../../assets/temp/blog-arcitecture.jpg";
import blogLandScape from "../../assets/temp/blog-landscape.jpg";
import blogPhotographer from "../../assets/temp/blog-photographer.jpg";

import { ReactComponent as EyeSvg } from "../../assets/icons/eye-gray.svg";
import { ReactComponent as FilterSvg } from "../../assets/icons/filter.svg";
import { ReactComponent as RemoveSvg } from "../../assets/filters/remove.svg";
import { Tooltip } from "react-tooltip";
import _ from "lodash";
import ContentLoader from "react-content-loader";
import useScreenSize from "../../hooks/useScreenSize.js";

const assetsURI = import.meta.env.ASSETS_URI;

const Blogs = ({}) => {
  const [blogs, setBlogs] = useState([]);
  const [metadata, setMetadata] = useState(undefined);
  const [highlight, setHighlight] = useState([]);
  const [limit, setLimit] = useState(6);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isHighlightLoading, setIsHighlightLoading] = useState(true);
  const navigate = useNavigate();
  const { queryBlog } = useBlogs();
  const { designStyles, getLang } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);
  const { screenSize } = useScreenSize();
  const [searchParams] = useSearchParams();
  const [filter, setFilter] = useState({
    deleted: false,
    status: 1,
  });

  const changeDefaultFilter = () => {
    setFilter({
      deleted: false,
      status: 1,
    });
  };

  useEffect(() => {
    changeDefaultFilter();
    return () => {};
  }, []);

  useEffect(() => {
    const tag = searchParams.get("tag");
    if (tag) {
      setFilter((curr) => ({
        ...curr,
        tags: { $in: [tag] },
      }));
    } else {
      changeDefaultFilter();
    }
  }, [searchParams]);

  useEffect(() => {
    fetchData();
    fetchHighlight();
  }, [limit, page, filter]);

  const handleOnPageChange = (page) => {
    setPage(page);
    window.scrollTo(0, 900);
  };
  const formatView = (n) => {
    if (n < 1e3) return n;
    if (n >= 1e3) return +(n / 1e3).toFixed(1) + "K";
  };
  const handleOnLimitChange = (limit) => setLimit(limit);
  const handleClearTagFilter = () => {
    changeDefaultFilter();
    navigate(`/blogs`);
  };

  const fetchHighlight = async () => {
    const { data, _metadata } = await queryBlog(
      {
        deleted: false,
        status: 1,
      },
      1,
      5,
      {
        name: 1,
        cover: 1,
        tags: 1,
        desc: 1,
        createdOn: 1,
        effectiveDate: 1,
        priorities: 1,
        views: 1,
      },
      { "priorities.value": 1, createdOn: -1 }
    );

    setHighlight(data);
    setIsHighlightLoading(false);
  };

  const fetchData = async () => {
    setIsLoading(true);
    const { data, _metadata } = await queryBlog(
      filter,
      page,
      limit,
      {
        name: 1,
        cover: 1,
        tags: 1,
        createdOn: 1,
        desc: 1,
        effectiveDate: 1,
        priorities: 1,
        views: 1,
      },
      // { "priorities.value": 1, createdOn: 1 }
      { createdOn: -1 }
    );

    setBlogs(data);
    setMetadata(_metadata);
    setIsLoading(false);
  };

  const tagList = (tags, length) => {
    if (tags?.length > 3) {
      const list = tags.slice(0, length);
      const tooltips = tags.slice(length).join(",");
      const mapList = list.map((tag, index) => {
        return (
          <div
            key={`tags-key-${index}`}
            className="blog-detail-content-header-tags__chip"
            onClick={() => navigate(`/blogs?tag=${tag}`)}
          >
            {tag}
          </div>
        );
      });
      return (
        <>
          {mapList}
          {tags.length - list.length > 0 ? (
            <>
              <div
                key={`tags-key-more}`}
                className="blog-detail-content-header-tags__chip"
                data-tooltip-id="tag-tooltip"
                data-tooltip-content={`${tooltips}`}
              >
                +{tags.length - list.length}
              </div>
              <Tooltip id="tag-tooltip" />
            </>
          ) : (
            <></>
          )}
        </>
      );
    } else {
      return tags?.map((tag, index) => {
        return (
          <div
            key={`tags-key-${index}`}
            className="blog-detail-content-header-tags__chip"
            onClick={() => navigate(`/blogs?tag=${tag}`)}
          >
            {tag}
          </div>
        );
      });
    }
  };

  const cardLoading = (props) => {
    return (
      <ContentLoader
        speed={2}
        width={460}
        height={500}
        viewBox="0 0 480 520"
        backgroundColor="#f5f6f7"
        foregroundColor="#eee"
        style={{
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
        }}
        {...props}
      >
        <rect x="5" y="12" rx="30" ry="30" width="397" height="389" />
        <rect x="10" y="411" rx="2" ry="2" width="192" height="14" />
        <rect x="320" y="411" rx="2" ry="2" width="80" height="14" />
        <rect x="10" y="434" rx="2" ry="2" width="225" height="23" />
        <rect x="10" y="463" rx="2" ry="2" width="387" height="20" />
        <rect x="10" y="488" rx="2" ry="2" width="387" height="20" />
      </ContentLoader>
    );
  };

  const imageLoading = (props) => {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={460}
        viewBox="0 0 400 460"
        backgroundColor="#f5f6f7"
        foregroundColor="#eee"
        {...props}
        style={{
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <rect x="0" y="0" rx="30" ry="30" width="400" height="460" />
      </ContentLoader>
    );
  };

  const highlightLoading = (props) => {
    return (
      <ContentLoader
        speed={2}
        width={1080}
        height={1080}
        viewBox="0 0 1080 1080"
        backgroundColor="#f5f6f7"
        foregroundColor="#eee"
        {...props}
        style={{
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <path d="M 15.665 43.665 c 0 -21.605 22.672 -39.12 50.64 -39.12 h 948.445 c 27.968 0 50.64 17.515 50.64 39.12 v 992.67 c 0 21.606 -22.672 39.12 -50.64 39.12 H 727.79 c -27.968 0 -50.64 -17.514 -50.64 -39.12 v -28.932 c 0 -21.606 -22.672 -39.12 -50.64 -39.12 h -89.675 c -27.968 0 -50.64 -17.515 -50.64 -39.12 V 900.23 c 0 -21.606 -22.672 -39.12 -50.64 -39.12 H 66.305 c -27.968 0 -50.64 -17.514 -50.64 -39.12 V 43.665 z" />
        <path d="M 15.665 43.665 c 0 -21.605 22.672 -39.12 50.64 -39.12 h 948.445 c 27.968 0 50.64 17.515 50.64 39.12 v 992.67 c 0 21.606 -22.672 39.12 -50.64 39.12 H 727.79 c -27.968 0 -50.64 -17.514 -50.64 -39.12 v -28.932 c 0 -21.606 -22.672 -39.12 -50.64 -39.12 h -89.675 c -27.968 0 -50.64 -17.515 -50.64 -39.12 V 900.23 c 0 -21.606 -22.672 -39.12 -50.64 -39.12 H 66.305 c -27.968 0 -50.64 -17.514 -50.64 -39.12 V 43.665 z" />
        <rect x="36" y="882" rx="0" ry="0" width="250" height="32" />
        <rect x="316" y="882" rx="0" ry="0" width="128" height="33" />
        <rect x="36" y="931" rx="0" ry="0" width="422" height="60" />
        <rect x="34" y="1001" rx="0" ry="0" width="580" height="41" />
        <rect x="35" y="1050" rx="0" ry="0" width="580" height="38" />
      </ContentLoader>
    );
  };

  const listLoading = (length) => {
    const result = [];
    for (let i = 1; i <= length; i++) {
      result.push(cardLoading());
    }
    return result;
  };

  const handelClickRead = (_id) => {
    navigate(`/blogs/${_id}`);
  };

  const formatDate = (_date) => {
    if (!_date) return "";

    const dt = new Date(_date);
    const date = dt.getDate();
    const month = dt.toLocaleDateString("default", { month: "short" });
    const year = dt.getFullYear();
    return `${date} ${month} ${year}`;
  };

  const blogCard = ({
    _id,
    name,
    cover,
    desc,
    views,
    effectiveDate,
    createdOn,
    tags,
  }) => {
    return (
      <div id={_id} className="blog-list-content-card">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            // height: "100%",
          }}
        >
          <img
            className="blog-list-content-card__cover"
            onClick={() => handelClickRead(_id)}
            alt={`Cover Image of ${name}`}
            src={`${assetsURI}/${cover}`}
          />
          <div className="blog-list-content-card-category">
            <div className="blog-list-content-card-category-detail">
              <div className="blog-list-content-card-category-detail__date">
                {formatDate(createdOn)}
              </div>
            </div>
            <div className="blog-list-content-card-category-view">
              <EyeSvg />
              {views ? formatView(views) : 0}
            </div>
          </div>
          <div className="blog-list-content-card__name">{name}</div>
          <div className="blog-list-content-card__tags">
            {tags ? tagList(tags, 5) : ""}
          </div>

          <div className="blog-list-content-card__description">{desc}</div>
        </div>
        <div
          className="blog-list-content-card__action"
          onClick={() => handelClickRead(_id)}
        >
          {TranslationCommon("Read")}
          <ArrowRightSvg />
        </div>
      </div>
    );
  };

  const canDisplayHighlight = highlight.length > 0;

  return (
    <div className="blog">
      <ScrollToTop />
      <div className="blog__header">{TranslationCommon("Blogs")}</div>
      <div
        className="blog-highlight"
        // style={{ display: ["xs", "sm"].includes(screenSize) ? "none" : "grid" }}
      >
        {isHighlightLoading && (
          <div style={{ width: "100%", height: "100%" }}>
            {!["xs", "sm"].includes(screenSize) ? highlightLoading() : ""}
          </div>
        )}
        {canDisplayHighlight && (
          <div
            className="blog-highlight-main"
            onClick={() => handelClickRead(highlight[0]?._id)}
          >
            <div className="blog-highlight-main__mask-image">
              <img
                alt={"Highlight image cover"}
                src={`${assetsURI}/${highlight[0]?.cover}`}
              />
            </div>
            <div className="blog-highlight-main-info">
              <div className="blog-highlight-main-info-header">
                <div className="blog-highlight-main-info-header__date">
                  {formatDate(highlight[0].createdOn)}
                </div>
                <div className="blog-highlight-main-info-header__tags">
                  <EyeSvg />
                  {highlight[0].views ? formatView(highlight[0].views) : 0}
                </div>
              </div>
              <div className="blog-highlight-main-info__name">
                {highlight[0]?.name}
              </div>
            </div>
          </div>
        )}
        <div className="blog-highlight-category">
          <div className="blog-highlight-category-top">
            {highlight?.length >= 2 && (
              <div
                className={`blog-highlight-category-content-image${
                  !isHighlightLoading ? "" : "__loading"
                }`}
              >
                <div
                  className={`blog-highlight-category-content-image${
                    !isHighlightLoading ? "" : "__loading"
                  }__left`}
                  onClick={() => handelClickRead(highlight[1]?._id)}
                  style={{
                    width: ["md"].includes(screenSize) ? "auto" : "60%",
                  }}
                >
                  {!isHighlightLoading ? (
                    <img
                      alt={"Landscape picture"}
                      src={
                        highlight
                          ? `${assetsURI}/${highlight[1]?.cover}`
                          : blogLandScape
                      }
                    />
                  ) : (
                    imageLoading()
                  )}
                  <div className="blog-highlight-category-content-info">
                    <div className="blog-highlight-category-content-info-header">
                      <div className="blog-highlight-category-content-info-header__date">
                        {formatDate(highlight[1]?.createdOn ?? new Date())}
                      </div>
                      <div className="blog-highlight-category-content-info-header__tags">
                        <EyeSvg />
                        {highlight[1]?.views
                          ? formatView(highlight[1]?.views)
                          : 0}
                      </div>
                    </div>
                    <div className="blog-highlight-category-content-info__name">
                      {highlight[1]?.name}
                    </div>
                  </div>
                </div>
                <div
                  className={`blog-highlight-category-content-image${
                    !isHighlightLoading ? "" : "__loading"
                  }__right`}
                  style={{
                    display: ["md"].includes(screenSize) ? "none" : "flex",
                    visibility: highlight[2] ? "visible" : "hidden",
                  }}
                  onClick={() => handelClickRead(highlight[2]?._id)}
                >
                  {!isHighlightLoading ? (
                    <img
                      alt={"Architecture picture"}
                      src={
                        highlight
                          ? `${assetsURI}/${highlight[2]?.cover}`
                          : blogArchitecture
                      }
                    />
                  ) : (
                    imageLoading()
                  )}
                  {highlight?.length >= 3 && (
                    <div className="blog-highlight-category-content-info">
                      <div className="blog-highlight-category-content-info-header">
                        <div className="blog-highlight-category-content-info-header__date">
                          {formatDate(highlight[2]?.createdOn)}
                        </div>
                        <div className="blog-highlight-category-content-info-header__tags">
                          <EyeSvg />
                          {highlight[2]?.views
                            ? formatView(highlight[2]?.views)
                            : 0}
                        </div>
                      </div>
                      <div className="blog-highlight-category-content-info__name">
                        {highlight[2]?.name}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        {highlight?.length >= 4 && (
          <div
            className={`blog-highlight-category-content-image-2${
              !isHighlightLoading ? "" : "__loading"
            }`}
          >
            <div className="blog-highlight-category-top">
              <div
                className={`blog-highlight-category-content-image-2${
                  !isHighlightLoading ? "" : "__loading"
                }`}
              >
                <div
                  className={`blog-highlight-category-content-image-2${
                    !isHighlightLoading ? "__left" : "__loading__left"
                  }`}
                  onClick={() => handelClickRead(highlight[3]?._id)}
                  style={{
                    display: ["md"].includes(screenSize) ? "none" : "flex",
                  }}
                >
                  {!isHighlightLoading ? (
                    <img
                      alt={"Photographer picture"}
                      src={
                        highlight
                          ? `${assetsURI}/${highlight[3]?.cover}`
                          : blogPhotographer
                      }
                    />
                  ) : (
                    imageLoading()
                  )}
                  <div className="blog-highlight-category-content-info">
                    <div className="blog-highlight-category-content-info-header">
                      <div className="blog-highlight-category-content-info-header__date">
                        {formatDate(highlight[3]?.createdOn)}
                      </div>
                      <div className="blog-highlight-category-content-info-header__tags">
                        <EyeSvg />
                        {highlight[3]?.views
                          ? formatView(highlight[3]?.views)
                          : 0}
                      </div>
                    </div>
                    <div className="blog-highlight-category-content-info__name">
                      {highlight[3]?.name}
                    </div>
                  </div>
                </div>
                <div
                  className={`blog-highlight-category-content-image-2${
                    !isHighlightLoading ? "__right" : "__loading__right"
                  }`}
                  onClick={() => handelClickRead(highlight[4]?._id)}
                  style={{
                    display: ["md"].includes(screenSize) ? "none" : "flex",
                    visibility: highlight[4] ? "visible" : "hidden",
                  }}
                >
                  {!isHighlightLoading ? (
                    <img
                      alt={"Photographer picture"}
                      src={
                        highlight
                          ? `${assetsURI}/${highlight[4]?.cover}`
                          : blogPhotographer
                      }
                    />
                  ) : (
                    imageLoading()
                  )}
                  <div className="blog-highlight-category-content-info">
                    <div className="blog-highlight-category-content-info-header">
                      <div className="blog-highlight-category-content-info-header__date">
                        {formatDate(highlight[4]?.createdOn)}
                      </div>
                      <div className="blog-highlight-category-content-info-header__tags">
                        <EyeSvg />
                        {highlight[4]?.views
                          ? formatView(highlight[4]?.views)
                          : 0}
                      </div>
                    </div>
                    <div className="blog-highlight-category-content-info__name">
                      {highlight[4]?.name}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        className="blog-filter"
        style={{ display: searchParams.get("tag") ? "flex" : "none" }}
      >
        {/* <div className="blog-filter__button">
          <FilterSvg
            className="blog-filter__button__icon"
            style={{ cursor: "pointer" }}
          />
          <span className="blog-filter__button__text">Filter</span>
        </div> */}

        <div className="blog-filter-content">
          <div className="blog-filter-content__value">
            {searchParams.get("tag")}
          </div>
          <RemoveSvg
            width={14}
            height={14}
            className="blog-filter-content__remove"
            onClick={handleClearTagFilter}
          />
        </div>
      </div>
      <div className="blog-list">
        <div className="blog-list-content">
          {!isLoading
            ? blogs.map((b) => {
                return blogCard(b);
              })
            : listLoading(limit)}
        </div>
      </div>
      <div className="blog-pagination">
        <Pagination
          defaultPage={metadata?.currentPage || 1}
          pages={metadata?.totalPages || 1}
          onPageChange={(page) => handleOnPageChange(page)}
          onLimitChange={(limit) => handleOnLimitChange(limit)}
        />
      </div>
    </div>
  );
};

Blogs.propTypes = {};

Blogs.defaultProps = {};

export default Blogs;
